export default __webpack_public_path__ + "static/media/q3_step1.4d91f190.png";